import React from 'react';
import { styled } from '@ff/ui';
import Box, { BoxProps } from '@ff/ui/Box';

interface Props extends BoxProps {
  name: string;
}

export default function Folder(props: Props) {
  const { onClick, name } = props;

  return (
    <Container
      onClick={onClick}
    >
      <i className="material-icons">folder</i>
      {name}
    </Container>
  );
}

const Container = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  fontWeight: 'bold'
});
